import type { FC } from "react";

import { Box, Typography } from "@mui/material";
import CustomTextField from "../../CustomTextField";
import CustomDropdown from "../../CustomDropdown";
import PixelStatus from "../../PixelStatus";
import CustomButton from "../../CustomButton";
import PixelConnectionModal from "../../PixelConnectionModal";
import AddWebModal from "../../../screens/Websites/AddWebModal";
import DeleteWebModal from "../../DeleteWebModal";

import { useTranslation } from "react-i18next";
import { useSettingsContext } from "../../../context/SettingsContext";
import { isUSA } from "../../../constants/env";

import { memo } from "react";

export const WebSettingsTab: FC = memo(function WebSettingsTabMemoized() {
  const { t } = useTranslation();
  const {
    isCheckLoading,
    isConnected,
    isPixelModalOpen,
    isAddWebModalOpen,
    isDeleteModalOpen,
    checkPixelStatus,
    isDeleting,
    classes,
    webName,
    webUrl,
    user,
    selectedLanguage,
    onLanguageChange,
    handleWebNameChange,
    handleWebUrlChange,
    handleDeleteWeb,
    setIsAddWebModalOpen,
    setIsDeleteModalOpen,
    setIsPixelModalOpen,
  } = useSettingsContext();

  return (
    <>
      <Box className={classes.container}>
        <Box style={{ width: 376 }}>
          <Typography className={classes.webName}>{webName}</Typography>
          <CustomTextField
            style={{ marginTop: 46 }}
            fullWidth
            disabled
            label={t("addWebsite.name") ?? ""}
            value={webName}
            onChange={handleWebNameChange}
          />

          <CustomTextField
            style={{ marginTop: 46, marginBottom: 46 }}
            fullWidth
            disabled
            label={`${t("addWebsite.url")} (${t("addWebsite.includeHttps")})`}
            value={webUrl}
            onChange={handleWebUrlChange}
          />

          <CustomDropdown
            disabled
            id='language-dropdown'
            label={t("addWebsite.notificationLanguage")}
            items={isUSA ? [
              { title: "English", value: "en" },
            ] : [
              { title: t("contact.address.slovakia"), value: "sk" },
              { title: t("contact.address.czechRepublic"), value: "cs" },
              { title: t("contact.address.polish"), value: "pl" },
            ]}
            onChange={onLanguageChange}
            value={selectedLanguage}
          />
          <Box className={classes.statusContainer}>
            <Box className={classes.statusRow}>
              <Typography className={classes.statusTitle}>Pixel</Typography>
              <PixelStatus
                isConnected={isConnected}
                isLoading={isCheckLoading}
                onClick={() => setIsPixelModalOpen(true)}
              />
            </Box>
          </Box>
        </Box>
        <CustomButton
          size='medium'
          style={{ width: 100, marginTop: 16 }}
          type='primary'
          onClick={() => setIsAddWebModalOpen(true)}
          title={t("edit")}
        />
      </Box>
      <PixelConnectionModal
        isOpen={isPixelModalOpen}
        onClose={() => setIsPixelModalOpen(false)}
        onPixelVerified={() => {
          checkPixelStatus();
        }}
      />
      <AddWebModal
        userInfo={user}
        update
        isOpen={isAddWebModalOpen}
        title={t("sidePanel.settings") ?? ""}
        primaryButtonTitle={t("save") ?? ""}
        secondaryButtonTitle={t("close") ?? ""}
        onClose={() => setIsAddWebModalOpen(false)}
        completedWebName={webName}
        completedWebUrl={webUrl}
        completedLanguage={selectedLanguage}
      />
      <DeleteWebModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onDelete={handleDeleteWeb}
        isLoading={isDeleting}
      />
    </>
  );
});
